import { createApp, ref, onMounted, defineComponent, toRefs } from 'vue';
import { CrowdHandlerWR } from './CrowdHandler';
import './styles/main.scss';  // Add this line

document.addEventListener('DOMContentLoaded', () => {
  const templateEl = document.getElementById('crowdhandler-template');
  const bodyEl = document.body;

  if (!templateEl) {
    console.error('CrowdHandler Template not found');
    return;
  }

  const template = bodyEl.innerHTML.trim();

  const AppComponent = defineComponent({
    template: template,
    setup() {
      const crowdData = CrowdHandlerWR();
      return crowdData;  // Return the reactive object directly
    }
  });

  // Create and mount the app
  const app = createApp(AppComponent);
  app.mount(document.body);
});